import { createAction, ActionType, createReducer } from 'typesafe-actions';
import { TEACHER_TYPES } from '../../utils/constants';
import { normalizeAccountProvider } from '../../utils/account_provider';

interface TableSortPayloadType {
  columnKey: keyof TableSortListType;
  sortKey: string;
  sortValue: string;
}

const initialState: UserType = {
  uid: 0,
  cid: 0,
  uclass: '0',
  uname: '',
  pass: false,
  alimtalkuse: 0,
  appreviewdone: 0,
  bepaid: 0,
  checkmoney: 0,
  memtype: '',
  postdate: '',
  smscnt: 0,
  smsok: 0,
  smsstop: '0',
  ubirth: '',
  uloginid: '',
  uphone: '',
  attendancesms: '',
  cname: '',
  phone: '',
  cell: '',
  attendance_alim_abs: 0,
  attendance_alim_att: 0,
  attendance_alim_title: 0,
  attendance_sms_abs: null,
  attendance_sms_att: null,
  attendance_sms_abs_msg: '',
  attendance_sms_att_msg: '',
  attendance_sms_title: '',
  attendance_alim_absence: 0,
  attendance_sms_absence: 0,
  attendance_absence_time: 0,
  account_alim_contents: '',
  account_alim_costday: 0,
  account_alim_direct: 0,
  account_alim_direct_msg: '',
  account_first_time: 0,
  account_second_date: 0,
  account_second_time: 0,
  account_second_notice: 0,
  use_attendance_msg: 0,
  avaouttime: 0,
  stdtime: 0,
  attendancemulti: 0,
  usehourformat: 0,
  president: '',
  logofile: '',
  logofile_type: '',
  profile: '',
  profile_type: '',
  smsphone: '',
  sms_err_status: null,
  smsstartday: 0,
  is_teacher: false,
  pwdate: '',
  free_end_date: '',
  current_list_num: 0,
  login: 0,
  autosms: 0,
  whenautosms: 0,
  autosmscontent: '',
  restime: '',
  account_sms: null,
  account_sms_msg: '',
  product_change_status: 0,
  pretest: 0,
  transfer_date: null,
  is_mobile: false,
  notice_lms: false,
  account_registration: 0,
  account_provider: null,
  sp_pkid: null,
  cost: null,
  payment: null,
  notice_payment: false,
  // 수납관리 (사업자 정보)
  account_phone: '',
  account_number: '',
  business_number: '',
  ceo_name: '',
  customer: '',
  bank: '',
  // v2이면서 수납관리 사용자
  useaccount: 0,
  open_account: false,
  // 지출증빙 정보 미기입시 팝업 여부 (0: 안보이게, 1: 보이도록)
  notice_envidence: 0,
  // 수납 사용 가능여부
  open: 0,
  account_before: 0,
  account_before_date: 0,
  account_before_time: 0,
  mallkind: '',
  account_expire: 0,
  account_expire_time: 0,
  spam_notice: false,
  tableSort: {
    account_calculate_academy: {
      sortKey: null,
      sortValue: null,
    },
    account_calculate_user: {
      sortKey: null,
      sortValue: null,
    },
    account_check: {
      sortKey: null,
      sortValue: null,
    },
    account_manage_list: {
      sortKey: null,
      sortValue: null,
    },
    account_manage_create: {
      sortKey: null,
      sortValue: null,
    },
    account_statistics_period: {
      sortKey: null,
      sortValue: null,
    },
    account_statistics_daily: {
      sortKey: null,
      sortValue: null,
    },
    account_statistics_detail: {
      sortKey: null,
      sortValue: null,
    },
    attendance_covid_record: {
      sortKey: null,
      sortValue: null,
    },
    attendance_covid_unrecord: {
      sortKey: null,
      sortValue: null,
    },
    attendance_manager: {
      sortKey: null,
      sortValue: null,
    },
    attendance_status_record: {
      sortKey: null,
      sortValue: null,
    },
    attendance_status_unrecord: {
      sortKey: null,
      sortValue: null,
    },
    cash_charge: {
      sortKey: null,
      sortValue: null,
    },
    cash_used: {
      sortKey: null,
      sortValue: null,
    },
    setup_check: {
      sortKey: null,
      sortValue: null,
    },
    sms_detail: {
      sortKey: null,
      sortValue: null,
    },
    sms_send: {
      sortKey: null,
      sortValue: null,
    },
    sms_reservation: {
      sortKey: null,
      sortValue: null,
    },
    student_class: {
      sortKey: null,
      sortValue: null,
    },
    student_list: {
      sortKey: null,
      sortValue: null,
    },
    student_study: {
      sortKey: null,
      sortValue: null,
    },
    student_teacher: {
      sortKey: null,
      sortValue: null,
    },
    student_counsel: {
      sortKey: null,
      sortValue: null,
    },
    magazine_birthday: {
      sortKey: null,
      sortValue: null,
    },
  },
  // 링크발송 본인인증 해지 요청 고객여부
  isRequestUser: false,
  // 화면 zoom 상태
  zoom_status: 0,
  funnel_tutorial: {
    ft_postdate: null,
    tutorial_stage: 0,
  },
  first_paymentdate: null,
  recommend_code: null, // * 추천인 코드
  absence_alim: null, // * 결석 안내
};

export const CLEAR_USER = 'UserReducder/CLEAR_USER';
export const SET_USER = 'UserReducder/SET_USER';
export const SET_FREE_END_USER = 'UserReducder/SET_FREE_END_USER';
export const SET_STOP_USER = 'UserReducder/SET_STOP_USER';
export const SET_USER_TABLE_SORT = 'UserReducer/SET_USER_TABLE_SORT';

export const clearUser = createAction(CLEAR_USER)();
export const setUser = createAction(SET_USER)<UserType>();
export const setFreeEndUser = createAction(SET_FREE_END_USER)();
export const setStopUser = createAction(SET_STOP_USER)();
export const setUserTableSort = createAction(SET_USER_TABLE_SORT)<TableSortPayloadType>();

export const actions = { setUser, clearUser, setFreeEndUser, setStopUser, setUserTableSort };
type UserReducderActions = ActionType<typeof actions>;

const UserReducder = createReducer<UserType, UserReducderActions>(initialState, {
  [CLEAR_USER]: state => {
    window.sessionStorage.removeItem('user');
    document.cookie = `a-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    return {
      uid: state.uid,
      cid: state.cid,
      uclass: '0',
      uname: '',
      pass: false,
      // 0: 사용 x, 1: 수납만 알림톡, 2: 출결만 알림톡, 3: 수납 + 출결 알림톡
      alimtalkuse: 0,
      appreviewdone: 0,
      bepaid: 0,
      checkmoney: 0,
      memtype: '',
      postdate: '',
      smscnt: 0,
      smsok: 0,
      smsstop: '0',
      ubirth: '',
      uloginid: '',
      uphone: '',
      attendancesms: '',
      cname: '',
      phone: '',
      cell: '',
      attendance_alim_abs: 0,
      attendance_alim_att: 0,
      attendance_alim_title: 0,
      attendance_sms_abs: null,
      attendance_sms_att: null,
      attendance_sms_abs_msg: '',
      attendance_sms_att_msg: '',
      attendance_sms_title: '',
      attendance_alim_absence: 0,
      attendance_sms_absence: 0,
      attendance_absence_time: 0,
      account_alim_contents: '',
      account_alim_costday: 0,
      account_alim_direct: 0,
      account_alim_direct_msg: '',
      account_first_time: 0,
      account_second_date: 0,
      account_second_time: 0,
      account_second_notice: 0,
      use_attendance_msg: 0,
      avaouttime: 0,
      stdtime: 0,
      attendancemulti: 0,
      usehourformat: 0,
      president: '',
      logofile: '',
      logofile_type: '',
      profile: '',
      profile_type: '',
      smsphone: '',
      sms_err_status: null,
      smsstartday: 0,
      is_teacher: false,
      pwdate: '',
      free_end_date: '',
      current_list_num: 0,
      login: 0,
      autosms: 0,
      whenautosms: 0,
      autosmscontent: '',
      restime: '',
      account_sms: null,
      account_sms_msg: '',
      product_change_status: 0,
      pretest: 0,
      transfer_date: null,
      is_mobile: false,
      notice_lms: false,
      account_registration: 0,
      account_provider: null,
      sp_pkid: null,
      cost: null,
      payment: null,
      notice_payment: false,
      // 수납관리 (사업자 정보)
      account_phone: '',
      account_number: '',
      business_number: '',
      ceo_name: '',
      customer: '',
      bank: '',
      // v2이면서 수납관리 사용자
      useaccount: 0,
      open_account: false,
      // 지출증빙 정보 미기입시 팝업 여부 (0: 안보이게, 1: 보이도록)
      notice_envidence: 0,
      open: 0,
      account_before: 0,
      account_before_date: 0,
      account_before_time: 0,
      mallkind: '',
      account_expire: 0,
      account_expire_time: 0,
      spam_notice: false,
      tableSort: {
        account_calculate_academy: {
          sortKey: null,
          sortValue: null,
        },
        account_calculate_user: {
          sortKey: null,
          sortValue: null,
        },
        account_check: {
          sortKey: null,
          sortValue: null,
        },
        account_manage_list: {
          sortKey: null,
          sortValue: null,
        },
        account_manage_create: {
          sortKey: null,
          sortValue: null,
        },
        account_statistics_period: {
          sortKey: null,
          sortValue: null,
        },
        account_statistics_daily: {
          sortKey: null,
          sortValue: null,
        },
        account_statistics_detail: {
          sortKey: null,
          sortValue: null,
        },
        attendance_covid_record: {
          sortKey: null,
          sortValue: null,
        },
        attendance_covid_unrecord: {
          sortKey: null,
          sortValue: null,
        },
        attendance_manager: {
          sortKey: null,
          sortValue: null,
        },
        attendance_status_record: {
          sortKey: null,
          sortValue: null,
        },
        attendance_status_unrecord: {
          sortKey: null,
          sortValue: null,
        },
        cash_charge: {
          sortKey: null,
          sortValue: null,
        },
        cash_used: {
          sortKey: null,
          sortValue: null,
        },
        setup_check: {
          sortKey: null,
          sortValue: null,
        },
        sms_detail: {
          sortKey: null,
          sortValue: null,
        },
        sms_send: {
          sortKey: null,
          sortValue: null,
        },
        sms_reservation: {
          sortKey: null,
          sortValue: null,
        },
        student_class: {
          sortKey: null,
          sortValue: null,
        },
        student_list: {
          sortKey: null,
          sortValue: null,
        },
        student_study: {
          sortKey: null,
          sortValue: null,
        },
        student_teacher: {
          sortKey: null,
          sortValue: null,
        },
        student_counsel: {
          sortKey: null,
          sortValue: null,
        },
        magazine_birthday: {
          sortKey: null,
          sortValue: null,
        },
      },
      // 실명인증 여부 (계정)
      // isCerti: 0,
      // 링크발송 본인인증 해지 요청 고객여부
      isRequestUser: false,
      zoom_status: 0,
      funnel_tutorial: {
        ft_postdate: null,
        tutorial_stage: 0,
      },
      first_paymentdate: null,
      recommend_code: null, // * 추천인 코드
      absence_alim: null, // * 결석 안내
    };
  },
  [SET_USER]: (state, action) => {
    const hasAccountProvider = Object.prototype.hasOwnProperty.call(action.payload, 'account_provider');

    return {
      ...state,
      ...action.payload,
      account_provider: hasAccountProvider
        ? normalizeAccountProvider(action.payload.account_provider)
        : state.account_provider,
      is_teacher: action.payload.uclass ? TEACHER_TYPES.includes(action.payload.uclass) : state.is_teacher,
    };
  },
  [SET_FREE_END_USER]: state => {
    return {
      ...state,
      smsstop: '1',
      funnel_tutorial: {
        ...state.funnel_tutorial,
        tutorial_stage: 6,
      },
      smscnt: 0,
    };
  },
  [SET_STOP_USER]: state => ({
    ...state,
    smsstop: '1',
  }),
  [SET_USER_TABLE_SORT]: (state, action) => {
    const new_state = {
      ...state,
      tableSort: {
        ...state.tableSort,
        [action.payload.columnKey]: {
          sortKey: action.payload.sortKey,
          sortValue: action.payload.sortValue,
        },
      },
    };
    if (window.sessionStorage.getItem('user')) {
      window.sessionStorage.setItem('user', JSON.stringify(new_state));
    }

    return new_state;
  },
});

export default UserReducder;
